import { render, staticRenderFns } from "./RegisterNew.vue?vue&type=template&id=38f6a1c0&lang=pug&"
import script from "./RegisterNew.vue?vue&type=script&lang=js&"
export * from "./RegisterNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports